import { ISurveyTemplateElementData } from './ISurveyTemplateElementData';
import { ISurveyTemplateElementGroupData } from './ISurveyTemplateElementGroupData';
import { ISurveyTemplateManifestationData } from './ISurveyTemplateManifestationData';
import { ISurveyTemplateUnitData } from './ISurveyTemplateUnitData';

export function isSurveyTemplateElementData(
    data: ISurveyTemplateElementData | ISurveyTemplateElementGroupData | ISurveyTemplateUnitData | ISurveyTemplateManifestationData,
): data is ISurveyTemplateElementData {
    return (data as ISurveyTemplateElementData).elementId !== undefined;
}
